import React from 'react'
import styles from './ProgressBar.module.css'

interface ProgressBarProps {
	value: number
	showLabel?: boolean
	color?: 'primary' | 'success' | 'warning' | 'danger'
	className?: string
	height?: string | number
	width?: string | number
}

const ProgressBar: React.FC<ProgressBarProps> = ({
	value,
	showLabel = false,
	color = 'primary',
	className = '',
	height,
	width,
}) => {
	const clampedValue = Math.max(0, Math.min(value, 100))
	const scaleX = clampedValue / 100

	console.log(clampedValue)

	const colorClass = styles[`progressBar--color_${color}`]
	const containerStyle: React.CSSProperties = {
		height:
			height !== undefined
				? typeof height === 'number'
					? `${height}px`
					: height
				: '24px',
		width:
			width !== undefined
				? typeof width === 'number'
					? `${width}px`
					: width
				: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		boxSizing: 'border-box',
	}

	return (
		<>
			<div
				className={`${styles.progressBar__container} ${className}`}
				style={containerStyle}
			>
				<div className={styles.progressBar__wrapper}>
					<div
						className={`${styles.progressBar__fill} ${colorClass}`}
						style={{
							transform: `scaleX(${scaleX})`,
							transition: 'transform 0.3s ease',
							width: '100%',
							height: '100%',
						}}
					></div>
					{showLabel && (
						<div
							className={styles.progressBar__label}
							style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								color: '#fff',
								minWidth: '100%',
								transition: 'transform 0.3s ease',
								transform: `translate(-${
									100 -
									(((clampedValue || 0) / 100) * 100) / 2 +
									(clampedValue < 1
										? 4
										: clampedValue < 2
										? 3
										: clampedValue < 3
										? 1
										: clampedValue < 4
										? 0
										: 0)
								}%, -50%)`,
							}}
						>
							{clampedValue}%
						</div>
					)}
				</div>
			</div>
		</>
	)
}

export default ProgressBar
